// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--workflow-main-content {
    max-width: 1920px;
    width: 100%;
    height: 100%;
    padding: 10px 130px 100px 130px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.scl--components-pagination-rowsPerPage span{
    font-family: var(--font-family-inter);
}

.scl--workflow-head-const-box {
    width: 100%;
}

.scl--workflow-filt-const-box {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 15px;
    padding-top: 15px;
    padding-right: 25px;
}

.scl-workflow-filt-summ {
    margin-left: auto;
}

.scl-workflow-filt-summ .btn-sum {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    transition: all 0.1s;
    border: none;
    border: 1px solid white;
}

.scl-workflow-filt-summ .btn-sum svg path {
    stroke: rgba(138, 139, 143, 0.5);
}

.scl-workflow-filt-summ .btn-sum:active svg path,
.scl-workflow-filt-summ .btn-sum:hover svg path {
    stroke: rgba(0, 0, 0, 0.8);
}

.scl-workflow-filt-summ .btn-sum:active {
    border: 1px solid rgba(142, 142, 147, 1);
    box-shadow:
        0 0 0 2px white,
        0 0 0 4px #2767d2;
}


.scl--workflow-filt-status {
    min-width: 108px;
}

.scl--workflow-filt-search {
    width: 279px;
}

.scl--workflow-filt-type {
    min-width: 108px;
}

.scl--workflow-action-const-sty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.scl--workflow-action-const-sty span {
    padding: 0;
    margin: 0;
    color: rgba(138, 139, 143, 0.2);
    font-size: 12px;
}

.scl--workflow-action-const-sty button {
    width: 19px;
    height: 19px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.scl--workflow-eye-btn-const-sty svg path,
.scl--workflow-eye-btn-const-sty svg circle {
    stroke: rgba(138, 139, 143, 1);
}

.scl--workflow-tras-btn-const-sty svg path {
    stroke: rgba(254, 86, 107, 1);
}

.scl--workflow-tras-btn-const-sty {
    border-radius: 4px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scl--workflow-eye-btn-const-sty {
    transition: all 0.3s;
    border-radius: 4px;
}

.scl--workflow-eye-btn-const-sty:hover {
    background-color: rgba(156, 156, 156, 0.24);
}

.scl--workflow-eye-btn-const-sty:hover svg,
.scl--workflow-eye-btn-const-sty:hover svg circle {
    stroke: black;
}

.scl--workflow-tras-btn-const-sty:hover {
    background: rgba(255, 236, 239, 1);
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main thead th {
    padding-left: 0px;
}

.scl--workflow-tabl-const-box {
    margin-top: 10px;
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter {
    text-transform: uppercase;
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2),
.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4),
.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5),
.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6) {
    color: var(--typography-text-body-secondary);
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td .badge-scl{
    text-transform: lowercase;
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td .badge-scl::first-letter{
    text-transform: uppercase;
}

.scl--bdc-cp-const-sty-box {
    gap: 4px;
    margin-bottom: 10px;
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td {
    max-width: 0;
    /* this is the key — forces fixed layout to actually clip */
    padding-left: 0px;
}

.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {
    width: 100%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    /* change from inline-flex to block */
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/workflow.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC;;yBAEqB;AACzB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2DAA2D;IAC3D,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,qCAAqC;AACzC","sourcesContent":[".scl--workflow-main-content {\n    max-width: 1920px;\n    width: 100%;\n    height: 100%;\n    padding: 10px 130px 100px 130px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.scl--components-pagination-rowsPerPage span{\n    font-family: var(--font-family-inter);\n}\n\n.scl--workflow-head-const-box {\n    width: 100%;\n}\n\n.scl--workflow-filt-const-box {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding-top: 15px;\n    padding-right: 25px;\n}\n\n.scl-workflow-filt-summ {\n    margin-left: auto;\n}\n\n.scl-workflow-filt-summ .btn-sum {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 1);\n    cursor: pointer;\n    transition: all 0.1s;\n    border: none;\n    border: 1px solid white;\n}\n\n.scl-workflow-filt-summ .btn-sum svg path {\n    stroke: rgba(138, 139, 143, 0.5);\n}\n\n.scl-workflow-filt-summ .btn-sum:active svg path,\n.scl-workflow-filt-summ .btn-sum:hover svg path {\n    stroke: rgba(0, 0, 0, 0.8);\n}\n\n.scl-workflow-filt-summ .btn-sum:active {\n    border: 1px solid rgba(142, 142, 147, 1);\n    box-shadow:\n        0 0 0 2px white,\n        0 0 0 4px #2767d2;\n}\n\n\n.scl--workflow-filt-status {\n    min-width: 108px;\n}\n\n.scl--workflow-filt-search {\n    width: 279px;\n}\n\n.scl--workflow-filt-type {\n    min-width: 108px;\n}\n\n.scl--workflow-action-const-sty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.scl--workflow-action-const-sty span {\n    padding: 0;\n    margin: 0;\n    color: rgba(138, 139, 143, 0.2);\n    font-size: 12px;\n}\n\n.scl--workflow-action-const-sty button {\n    width: 19px;\n    height: 19px;\n    border: none;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n}\n\n.scl--workflow-eye-btn-const-sty svg path,\n.scl--workflow-eye-btn-const-sty svg circle {\n    stroke: rgba(138, 139, 143, 1);\n}\n\n.scl--workflow-tras-btn-const-sty svg path {\n    stroke: rgba(254, 86, 107, 1);\n}\n\n.scl--workflow-tras-btn-const-sty {\n    border-radius: 4px;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scl--workflow-eye-btn-const-sty {\n    transition: all 0.3s;\n    border-radius: 4px;\n}\n\n.scl--workflow-eye-btn-const-sty:hover {\n    background-color: rgba(156, 156, 156, 0.24);\n}\n\n.scl--workflow-eye-btn-const-sty:hover svg,\n.scl--workflow-eye-btn-const-sty:hover svg circle {\n    stroke: black;\n}\n\n.scl--workflow-tras-btn-const-sty:hover {\n    background: rgba(255, 236, 239, 1);\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main thead th {\n    padding-left: 0px;\n}\n\n.scl--workflow-tabl-const-box {\n    margin-top: 10px;\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter {\n    text-transform: uppercase;\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2),\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4),\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5),\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6) {\n    color: var(--typography-text-body-secondary);\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td .badge-scl{\n    text-transform: lowercase;\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td .badge-scl::first-letter{\n    text-transform: uppercase;\n}\n\n.scl--bdc-cp-const-sty-box {\n    gap: 4px;\n    margin-bottom: 10px;\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-main tbody td {\n    max-width: 0;\n    /* this is the key — forces fixed layout to actually clip */\n    padding-left: 0px;\n}\n\n.scl--workflow-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {\n    width: 100%;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    /* change from inline-flex to block */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
